import PropTypes from 'prop-types'
import styled from 'styled-components'
import { linkToTitle } from '@utils'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'

const StyledLink = styled.a`
  font-weight: ${tokens.fontWeights.ivarDisplay3.value};
`

const WebsiteLink = ({ link, title }) =>
  (link && link.length ? (
    <StyledLink href={link} target='_blank' rel='nofollow noopener'>
      {title || linkToTitle(link)}
    </StyledLink>
  ) : null)

WebsiteLink.propTypes = {
  link: PropTypes.string,
  title: PropTypes.string
}

export default WebsiteLink
